export function getCurrendDashboardUrl(account, defaultPath = '/') {
  if (account) {
    let role = account.role ? account.role : localStorage.getItem('userType');
    if (role === 'operator') {
      defaultPath = '/dashboard';
      return defaultPath;
    } else if (role === 'dispatcher') {
      defaultPath = '/dispatcherDashboard';
      return defaultPath;
    }
    if (account.dashboardType !== 'regular') {
      return '/onDemandDashboard';
    }
  }
  return defaultPath;
}




// WEBPACK FOOTER //
// ./src/businessLogic/getCurrendDashboardUrl.js